import * as React from "react";

const SvgLocalizationStation = ({ ...props }) => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="1309.000000pt" height="709.000000pt" viewBox="0 0 1309.000000 709.000000"
 preserveAspectRatio="xMidYMid meet"     {...props}>

<g transform="translate(0.000000,709.000000) scale(0.100000,-0.100000)"
fill="currentColor" stroke="currentColor" strokeWidth={30}>
<path d="M5745 6756 c-297 -57 -607 -116 -690 -131 l-150 -28 -42 -43 c-35
-36 -51 -44 -100 -53 -65 -12 -113 -52 -113 -96 0 -14 12 -38 28 -55 21 -24
40 -33 90 -41 34 -6 62 -16 62 -21 0 -5 15 -24 34 -42 27 -27 47 -36 102 -45
46 -8 120 -36 221 -83 149 -70 153 -72 174 -117 25 -55 69 -121 80 -121 4 0
-7 23 -26 52 -19 28 -32 55 -28 61 7 11 107 0 150 -18 20 -8 39 -28 51 -52 25
-46 63 -84 121 -116 l44 -25 -43 -12 c-71 -19 -144 5 -217 74 -18 16 -33 25
-33 19 0 -15 64 -65 124 -97 61 -33 109 -33 172 -1 27 14 55 25 62 25 8 0 43
-16 78 -36 35 -19 69 -32 75 -28 7 4 9 3 5 -4 -4 -6 15 -22 44 -38 51 -28 66
-54 30 -54 -19 0 -20 -7 -20 -100 l0 -99 -62 -3 -63 -3 -3 -101 -3 -100 -62
-13 c-138 -28 -380 -107 -371 -122 3 -5 -2 -6 -10 -3 -20 8 -177 -66 -169 -79
3 -6 1 -7 -5 -3 -16 10 -114 -42 -106 -56 4 -7 3 -8 -4 -4 -14 9 -75 -22 -67
-34 3 -5 0 -12 -6 -16 -8 -5 -9 -3 -4 6 5 8 3 11 -6 8 -8 -3 -14 -10 -14 -15
0 -6 -4 -15 -9 -20 -5 -5 -6 -3 -2 5 10 17 -5 15 -32 -4 -12 -8 -20 -19 -17
-24 3 -5 0 -12 -6 -16 -8 -5 -9 -3 -4 6 5 8 3 11 -6 8 -8 -3 -14 -10 -14 -15
0 -6 -4 -15 -9 -20 -5 -5 -6 -2 -1 6 5 9 3 12 -6 9 -8 -3 -14 -10 -14 -16 0
-6 -7 -17 -15 -24 -12 -11 -12 -11 -1 5 7 9 9 17 3 17 -12 0 -34 -25 -27 -32
3 -3 -3 -11 -12 -19 -16 -13 -17 -12 -4 4 7 9 9 17 4 17 -13 0 -45 -35 -38
-42 3 -3 -3 -11 -12 -19 -16 -13 -17 -12 -4 4 7 9 9 17 4 17 -13 0 -45 -35
-38 -41 3 -3 -12 -21 -33 -40 l-37 -34 34 38 c19 20 31 37 25 37 -12 0 -254
-242 -254 -254 0 -5 12 1 28 15 18 15 15 11 -7 -13 -19 -21 -37 -36 -40 -33
-6 7 -41 -25 -41 -38 0 -5 8 -3 18 4 15 13 16 12 3 -4 -8 -9 -16 -15 -19 -12
-7 7 -32 -15 -32 -27 0 -6 8 -4 18 3 15 13 16 12 3 -4 -8 -9 -16 -15 -19 -12
-7 7 -32 -15 -32 -27 0 -6 8 -4 18 3 15 13 16 12 3 -4 -8 -9 -16 -15 -19 -12
-7 7 -32 -15 -32 -27 0 -6 8 -4 18 3 15 13 16 12 4 -3 -8 -10 -19 -16 -24 -15
-6 1 -13 -4 -16 -12 -3 -9 0 -11 9 -6 8 5 11 4 6 -1 -5 -5 -14 -9 -20 -9 -5 0
-12 -6 -15 -14 -3 -9 0 -11 8 -6 9 5 11 4 6 -4 -4 -6 -11 -9 -16 -6 -5 3 -14
-3 -19 -14 -14 -26 -14 -34 2 -25 7 4 9 3 4 -2 -5 -5 -14 -9 -20 -9 -5 0 -12
-6 -15 -14 -3 -9 0 -11 8 -6 9 5 11 4 6 -4 -4 -6 -11 -9 -16 -6 -12 8 -53 -73
-44 -87 4 -7 3 -8 -5 -4 -14 9 -105 -178 -97 -200 3 -8 2 -13 -3 -10 -17 11
-89 -197 -131 -378 -39 -169 -53 -302 -54 -511 0 -271 30 -478 105 -710 57
-181 190 -472 209 -460 5 3 12 0 16 -6 4 -8 3 -9 -4 -5 -15 9 -15 1 -1 -25 5
-11 14 -17 19 -14 5 3 12 0 16 -6 5 -8 3 -9 -6 -4 -8 5 -11 3 -8 -6 3 -8 10
-14 15 -14 6 0 15 -4 20 -9 5 -5 3 -6 -4 -2 -16 9 -16 1 -2 -25 5 -11 14 -17
19 -14 5 3 12 0 16 -6 5 -8 3 -9 -6 -4 -8 5 -11 3 -8 -6 3 -8 10 -14 15 -14 6
0 15 -4 20 -9 5 -5 3 -6 -4 -2 -17 9 -17 -10 0 -21 6 -4 15 -8 19 -8 3 0 10
-4 15 -9 5 -5 3 -6 -4 -2 -7 4 -13 3 -13 -3 0 -10 19 -26 32 -26 3 0 10 -4 15
-9 5 -5 3 -6 -4 -2 -17 9 -17 -10 0 -21 6 -4 15 -8 19 -8 3 0 10 -4 15 -9 5
-5 3 -6 -4 -2 -20 11 -15 -4 12 -36 25 -30 25 -30 6 -56 -40 -56 -231 -241
-321 -312 -249 -192 -526 -332 -806 -405 -142 -37 -312 -65 -441 -72 l-113 -6
0 2342 0 2343 88 -6 c480 -35 882 -182 1240 -455 93 -70 268 -235 333 -313 26
-31 49 -54 52 -51 6 6 -94 115 -198 216 -266 260 -624 457 -1000 552 -149 37
-380 68 -475 63 l-65 -3 -3 -2330 c-1 -1282 0 -2340 3 -2352 5 -22 8 -23 98
-17 319 18 603 91 875 224 271 132 505 308 693 522 l68 77 81 -90 c45 -49 87
-89 93 -89 6 0 -15 28 -48 63 -58 60 -58 60 13 -8 66 -63 94 -96 57 -65 -35
29 -11 -3 31 -42 50 -47 78 -63 54 -32 -12 17 -12 17 0 6 8 -7 15 -18 15 -25
0 -12 60 -61 157 -128 68 -47 95 -59 83 -38 -5 8 -5 11 1 6 5 -5 9 -14 9 -20
0 -5 6 -12 14 -15 9 -3 11 0 6 8 -5 9 -4 11 4 6 6 -4 9 -11 6 -16 -3 -5 8 -16
24 -25 36 -18 45 -19 35 -3 -4 7 -3 8 5 4 6 -4 9 -11 6 -16 -7 -11 160 -96
281 -143 123 -48 204 -73 309 -97 50 -12 98 -23 108 -26 16 -5 17 -28 17 -300
0 -189 4 -294 10 -294 6 0 10 105 10 296 l0 296 28 -6 c189 -39 614 -39 769 0
l23 6 0 -296 c0 -188 4 -296 10 -296 6 0 11 110 12 296 l3 296 130 33 c72 18
163 44 203 58 162 57 397 171 387 187 -3 5 0 12 6 16 8 4 9 3 5 -4 -11 -18 3
-14 51 14 24 14 41 29 38 34 -3 5 0 12 6 16 8 4 9 3 5 -4 -10 -17 6 -15 32 4
12 8 20 19 17 24 -3 5 0 12 6 16 8 4 9 3 5 -4 -11 -18 3 -14 35 9 16 11 27 24
24 29 -3 5 0 12 6 16 8 4 9 3 5 -4 -4 -7 -3 -12 3 -12 10 0 26 19 26 32 0 3 4
10 9 15 5 5 6 3 2 -4 -22 -38 59 26 191 151 l73 69 93 -91 c294 -291 651 -486
1061 -582 172 -40 468 -69 493 -49 11 10 13 419 13 2339 0 1281 -3 2335 -6
2344 -8 21 -118 21 -279 0 -493 -64 -909 -263 -1273 -609 -77 -73 -104 -94
-119 -88 -15 5 -14 1 7 -23 13 -16 -3 -2 -38 31 -34 33 -62 62 -62 64 0 3 18
-13 40 -34 22 -21 40 -35 40 -29 0 11 -154 154 -166 154 -4 0 3 -12 17 -27
l24 -28 -27 24 c-16 14 -26 27 -23 29 7 7 -36 52 -48 52 -6 0 -2 -10 9 -22
l19 -23 -22 19 c-12 10 -21 23 -20 28 1 6 -4 13 -12 16 -9 3 -11 0 -6 -8 5 -9
4 -11 -4 -6 -6 4 -9 11 -6 16 3 5 -10 20 -28 34 -39 30 -56 34 -36 9 13 -16
12 -17 -3 -5 -10 8 -16 19 -15 24 1 6 -4 13 -12 16 -9 3 -11 0 -6 -9 5 -8 4
-11 -1 -6 -5 5 -9 14 -9 20 0 7 -8 11 -18 11 -9 -1 -14 2 -12 7 3 4 -25 26
-63 48 -71 42 -88 49 -76 29 4 -7 3 -8 -5 -4 -6 4 -9 11 -6 16 8 12 -33 33
-51 26 -7 -3 -13 0 -11 6 5 26 -335 156 -520 198 l-103 24 0 103 0 103 -65 0
-65 0 0 100 0 100 -25 0 c-28 0 -30 8 -13 44 13 29 144 109 465 285 343 187
341 187 524 221 171 32 201 44 227 91 13 22 27 30 60 35 78 12 43 20 -95 23
-76 1 -140 5 -143 8 -3 2 64 3 148 1 l152 -3 0 70 0 70 -152 -2 c-84 -1 -139
2 -123 6 17 4 81 7 143 6 116 0 144 8 67 19 -25 4 -45 12 -45 17 0 6 -15 25
-34 43 l-34 32 -704 132 c-387 73 -716 132 -733 131 -16 0 -273 -47 -570 -103z
m921 28 c165 -31 450 -84 634 -119 l335 -63 -1305 0 c-718 0 -1300 1 -1295 3
6 3 87 18 180 35 94 17 287 53 430 80 143 28 341 65 440 84 99 19 203 35 231
35 29 1 186 -24 350 -55z m1112 -229 c12 -14 22 -30 22 -36 0 -5 -556 -9
-1475 -9 -811 0 -1475 3 -1475 8 0 15 32 54 50 60 11 4 657 6 1437 5 l1418 -2
23 -26z m-2931 -87 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m2058 10 c50 -1 -16 -5 -145 -8 -307 -7 -1884 1 -1846 9 27 5 1781 5 1991 -1z
m135 -2 c0 -11 -19 -15 -25 -6 -3 5 1 10 9 10 9 0 16 -2 16 -4z m275 -6 c-3
-5 -17 -10 -31 -10 -13 0 -24 5 -24 10 0 6 14 10 31 10 17 0 28 -4 24 -10z
m155 -6 c0 -2 -16 -4 -35 -4 -19 0 -35 4 -35 8 0 4 16 6 35 4 19 -2 35 -6 35
-8z m-90 -4 c0 -5 -9 -10 -20 -10 -11 0 -20 5 -20 10 0 6 9 10 20 10 11 0 20
-4 20 -10z m-2597 -7 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z
m30 -8 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z m2257 -1 c0 -8
-4 -12 -10 -9 -5 3 -10 10 -10 16 0 5 5 9 10 9 6 0 10 -7 10 -16z m117 9 c-20
-2 -52 -2 -70 0 -17 2 0 4 38 4 39 0 53 -2 32 -4z m406 0 c-13 -2 -35 -2 -50
0 -16 2 -5 4 22 4 28 0 40 -2 28 -4z m-603 -48 l0 -45 -1055 0 -1055 0 0 45 0
45 1055 0 1055 0 0 -45z m920 0 l0 -45 -132 0 -133 0 0 45 0 45 133 0 132 0 0
-45z m-3060 -7 c0 -40 0 -41 -20 -23 -23 21 -25 36 -8 53 21 21 28 13 28 -30z
m2204 19 c8 -13 6 -22 -12 -39 l-22 -22 0 43 c0 44 13 51 34 18z m-2265 -17
c-1 -17 -3 -19 -6 -7 -4 14 -17 17 -66 18 -58 2 -59 2 -22 9 22 4 52 7 68 6
22 0 27 -4 26 -26z m2304 17 c3 -8 1 -20 -4 -28 -6 -10 -9 -7 -9 14 0 29 5 35
13 14z m544 0 c3 -4 -114 -7 -260 -7 -147 0 -267 4 -267 8 0 10 517 9 527 -1z
m-2889 -34 c-16 -2 -40 -2 -55 0 -16 2 -3 4 27 4 30 0 43 -2 28 -4z m2744 0
c-73 -2 -190 -2 -260 0 -70 1 -10 3 133 3 143 0 200 -2 127 -3z m-2678 -19 c3
-8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z m2257 -7 c-13 -13 -26 -3
-16 12 3 6 11 8 17 5 6 -4 6 -10 -1 -17z m-2303 -4 c-16 -2 -40 -2 -55 0 -16
2 -3 4 27 4 30 0 43 -2 28 -4z m2715 0 c-73 -2 -193 -2 -265 0 -73 1 -14 3
132 3 146 0 205 -2 133 -3z m-498 -18 c6 -2 -467 -3 -1050 -2 -921 2 -979 2
-440 7 629 5 1472 3 1490 -5z m-665 -70 l0 -35 -502 0 c-277 0 -597 -1 -711
-1 -204 -1 -209 -1 -233 22 -54 51 -79 49 711 49 l735 0 0 -35z m1476 6 c-9
-16 -23 -32 -33 -36 -10 -4 -168 -6 -352 -6 -258 1 -337 -2 -343 -11 -6 -10
-8 -10 -8 0 0 9 -79 12 -360 12 l-360 0 0 35 0 35 735 0 736 0 -15 -29z
m-2456 -71 c20 -6 21 -8 5 -8 -11 0 -33 4 -50 8 -27 7 -27 8 -5 8 14 0 36 -4
50 -8z m595 0 c3 -5 24 -10 46 -10 21 0 39 5 39 10 0 6 40 10 100 10 55 0 100
-4 100 -9 0 -5 -4 -11 -10 -13 -5 -2 -1 -34 10 -78 11 -41 20 -78 20 -82 0 -5
-30 -8 -67 -8 -48 1 -177 25 -438 85 -203 46 -358 84 -342 84 15 1 27 6 27 11
0 6 91 10 254 10 159 0 257 -4 261 -10z m1640 1 c-6 -5 -27 -12 -47 -15 -31
-6 -37 -4 -32 9 4 10 19 15 47 15 24 0 37 -4 32 -9z m-2194 -98 c145 -83 179
-109 107 -79 -19 8 -68 24 -109 34 -41 11 -126 45 -189 75 l-115 55 79 1 79 1
148 -87z m1111 75 c-16 -21 -44 -129 -37 -146 5 -13 27 -14 167 -9 l161 7 -99
-103 c-55 -56 -126 -132 -158 -169 -56 -64 -62 -68 -102 -68 -51 0 -40 -26
-110 275 -25 104 -47 198 -50 208 -5 15 5 17 117 17 96 0 119 -3 111 -12z
m798 -74 c-255 -133 -697 -381 -728 -409 -7 -6 -26 -9 -42 -7 l-30 4 40 48
c22 27 93 103 156 169 l116 121 132 -6 131 -7 125 77 c69 43 124 81 123 87 -2
5 29 9 70 9 l72 0 -165 -86z m-1043 44 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3
-3 4 -12 1 -19z m613 -38 l-65 -60 -161 0 -162 0 16 60 16 60 211 0 210 -1
-65 -59z m315 0 l-100 -60 -128 0 -128 0 63 60 63 59 165 1 165 0 -100 -60z
m-1570 -108 c66 -41 145 -91 175 -112 75 -50 80 -53 80 -42 0 10 -137 102
-315 211 -54 33 -95 61 -90 61 10 0 618 -132 623 -135 3 -3 -20 -249 -24 -254
-2 -2 -38 21 -81 51 -98 68 -103 71 -103 60 0 -5 41 -37 91 -71 49 -35 88 -65
85 -68 -2 -3 -25 9 -50 26 -47 33 -62 38 -50 19 4 -6 -17 3 -47 20 -30 18 -83
48 -119 68 -36 19 -87 55 -115 80 -62 57 -55 53 124 -63 79 -52 146 -92 148
-89 7 7 -270 188 -452 296 -77 46 -144 88 -150 93 -18 18 148 -75 270 -151z
m652 106 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m10 -50 c-3 -7
-5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-839 -33 c-2 -1 -14 -5 -28 -8
-19 -5 -29 -1 -37 12 -11 17 -9 18 28 8 22 -5 38 -11 37 -12z m849 -7 c-3 -8
-6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m10 -40 c-3 -8 -6 -5 -6 6 -1
11 2 17 5 13 3 -3 4 -12 1 -19z m-188 -142 c-6 -74 -15 -134 -18 -131 -4 2 -1
59 6 127 6 68 12 129 12 137 1 8 4 12 7 9 3 -4 0 -67 -7 -142z m182 2 l26
-138 -100 0 -100 0 7 78 c4 42 9 105 13 140 l6 63 61 -3 61 -3 26 -137z m16
90 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-540 -96 c40 -19 43
-37 6 -28 -45 11 -116 59 -140 95 -38 56 -27 56 39 1 35 -29 78 -60 95 -68z
m550 56 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m10 -40 c-3 -8
-6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m27 -92 c8 -32 11 -55 7 -50 -9
10 -31 96 -30 116 1 17 5 5 23 -66z m-81 -83 c-29 -2 -77 -2 -105 0 -29 2 -6
3 52 3 58 0 81 -1 53 -3z m-123 -28 c0 -9 -9 -15 -25 -15 -24 0 -32 10 -18 23
12 13 43 7 43 -8z m230 -1 c0 -11 -22 -14 -105 -14 -88 0 -105 2 -105 15 0 14
16 16 105 14 82 -1 105 -4 105 -15z m200 1 c0 -12 -17 -15 -90 -15 -73 0 -90
3 -90 15 0 12 17 15 90 15 73 0 90 -3 90 -15z m-400 -125 l0 -90 -60 0 -60 0
0 90 0 90 60 0 60 0 0 -90z m290 0 l0 -90 -135 0 -135 0 0 90 0 90 135 0 135
0 0 -90z m150 0 l0 -90 -65 0 -65 0 0 90 0 90 65 0 65 0 0 -90z m130 -200 c0
-49 -3 -90 -7 -90 -5 0 -62 7 -128 15 -187 24 -440 19 -642 -11 l-43 -6 0 91
0 91 410 0 410 0 0 -90z m-497 -77 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0
24 -2 18 -5z m210 0 c-18 -2 -48 -2 -65 0 -18 2 -4 4 32 4 36 0 50 -2 33 -4z
m-366 -9 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m490 0 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m3073 -2328 l0 -2335 -72 5
c-282 19 -523 73 -757 171 -261 109 -514 277 -705 469 l-75 76 90 108 c86 104
103 129 77 114 -8 -4 -10 -3 -5 2 5 5 14 9 19 9 6 0 13 6 16 14 3 9 0 11 -9 6
-8 -5 -11 -4 -6 1 5 5 14 9 19 9 6 0 13 6 16 14 3 9 0 11 -9 6 -8 -5 -11 -4
-6 1 5 5 14 9 19 9 6 0 13 6 16 14 3 9 0 11 -9 6 -8 -5 -11 -4 -6 1 5 5 12 9
15 9 13 0 32 16 32 26 0 6 -5 7 -12 3 -7 -4 -8 -3 -4 5 4 6 11 9 16 6 12 -8
43 53 34 67 -4 7 -3 8 4 4 6 -4 18 6 27 23 18 36 19 45 3 35 -7 -4 -8 -3 -4 5
4 6 12 9 17 5 22 -13 155 310 209 506 59 219 74 341 74 610 0 210 -3 263 -22
370 -34 189 -79 348 -144 512 -5 15 -15 25 -21 21 -6 -4 -7 -1 -2 7 8 13 -44
132 -55 125 -4 -2 -6 6 -6 18 1 13 -4 21 -12 19 -8 -1 -11 2 -7 7 9 15 -24 73
-37 65 -7 -4 -8 -3 -4 4 9 14 -32 95 -44 87 -5 -3 -12 0 -16 6 -5 8 -3 9 6 4
8 -5 11 -3 8 6 -3 8 -10 14 -15 14 -6 0 -15 4 -20 9 -5 5 -3 6 5 2 18 -10 15
2 -9 35 -11 16 -24 27 -29 24 -5 -3 -12 0 -16 6 -5 8 -3 9 6 4 8 -5 11 -3 8 6
-3 8 -10 14 -16 14 -5 0 -14 4 -19 9 -5 5 -2 6 6 1 9 -5 12 -3 9 6 -3 8 -10
14 -16 14 -6 0 -17 7 -24 15 -11 12 -11 12 5 1 9 -7 17 -10 17 -6 0 8 -77 102
-134 163 l-41 44 99 95 c261 249 539 414 880 523 173 55 406 97 559 99 l77 1
0 -2334z m-3332 2317 c-10 -2 -28 -2 -40 0 -13 2 -5 4 17 4 22 1 32 -1 23 -4z
m349 1 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-540 -10 c-3
-3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m444 -19 c354 -42 661 -145
949 -320 95 -57 106 -63 94 -43 -4 7 -3 8 5 4 6 -4 9 -11 6 -16 -3 -5 8 -18
24 -29 32 -23 46 -27 35 -9 -4 7 -3 8 5 4 6 -4 9 -11 6 -16 -3 -5 8 -18 24
-29 33 -24 46 -27 35 -8 -4 6 2 3 14 -7 12 -11 20 -21 17 -24 -7 -7 25 -42 38
-42 5 0 3 8 -4 18 -7 9 -1 6 13 -7 15 -13 26 -27 25 -31 -1 -4 32 -38 73 -75
l75 -69 -65 70 c-51 54 -45 49 28 -21 50 -49 92 -92 92 -94 0 -3 -13 8 -30 24
-50 48 -34 18 29 -53 105 -119 113 -127 106 -114 -9 17 0 15 16 -5 12 -14 12
-16 0 -9 -9 6 -12 4 -9 -5 3 -8 10 -14 15 -14 6 0 15 -4 20 -9 5 -5 3 -6 -4
-2 -20 11 -15 -2 18 -50 16 -24 34 -42 39 -39 5 3 12 0 16 -6 5 -8 3 -9 -6 -4
-8 5 -11 3 -8 -6 3 -8 10 -14 15 -14 6 0 15 -4 20 -9 5 -5 3 -6 -4 -2 -21 12
-15 -3 31 -84 220 -380 333 -875 297 -1295 -29 -344 -94 -583 -239 -875 -42
-85 -76 -161 -76 -167 1 -7 -2 -11 -6 -8 -7 4 -100 -127 -100 -140 0 -4 6 -3
13 1 7 4 9 3 4 -2 -5 -5 -14 -9 -19 -9 -6 0 -13 -6 -16 -14 -3 -9 0 -11 9 -6
8 5 12 6 9 2 -3 -3 -8 -5 -11 -4 -10 3 -49 -34 -49 -46 0 -5 8 -3 18 4 15 13
16 12 3 -3 -7 -10 -17 -16 -21 -13 -4 3 -33 -25 -63 -63 -59 -72 -190 -201
-274 -271 -29 -24 -50 -47 -48 -52 3 -4 0 -11 -6 -15 -8 -4 -9 -3 -5 4 4 7 3
12 -3 12 -10 0 -26 -19 -26 -32 0 -3 -4 -10 -9 -15 -5 -5 -6 -3 -2 5 10 18 -2
15 -35 -9 -16 -11 -27 -24 -24 -29 3 -5 0 -12 -6 -16 -8 -4 -9 -3 -5 4 12 19
3 15 -110 -54 -289 -177 -624 -289 -969 -325 -147 -15 -451 -6 -583 16 -278
47 -521 129 -750 254 -99 54 -107 58 -96 39 4 -7 3 -8 -5 -4 -6 4 -9 11 -6 15
4 7 -126 101 -140 101 -4 0 -3 -6 1 -13 4 -6 5 -10 1 -7 -3 3 -5 8 -4 11 3 9
-24 39 -35 39 -6 0 -4 -8 3 -17 13 -16 12 -17 -4 -4 -9 8 -15 16 -12 19 7 7
-25 42 -38 42 -5 0 -3 -8 4 -17 13 -16 12 -17 -4 -4 -9 8 -15 16 -12 19 6 7
-15 32 -27 32 -5 0 -6 -6 -2 -12 5 -9 2 -8 -9 1 -10 8 -15 16 -12 19 7 7 -66
82 -79 82 -5 0 5 -16 24 -35 19 -19 32 -35 29 -35 -2 0 -49 46 -104 102 -70
72 -78 82 -26 33 67 -63 64 -59 -34 50 -60 66 -112 120 -116 120 -4 0 -11 4
-16 9 -5 5 -3 6 5 2 6 -4 12 -3 12 2 0 13 -25 33 -32 26 -3 -3 -9 0 -14 7 -4
8 -3 10 4 5 7 -4 12 -3 12 2 0 13 -25 33 -32 26 -3 -3 -9 0 -14 7 -4 8 -3 10
4 5 7 -4 12 -3 12 2 0 13 -25 33 -32 26 -3 -3 -9 0 -14 7 -5 8 -3 10 6 4 8 -5
11 -3 8 6 -3 8 -10 14 -16 14 -5 0 -14 4 -19 9 -5 5 -3 6 5 2 17 -10 15 2 -9
40 -11 19 -25 32 -29 29 -5 -3 -12 0 -16 6 -4 8 -3 9 4 5 18 -11 16 -6 -49
115 -182 341 -270 696 -270 1087 1 385 83 725 259 1067 69 132 68 130 52 120
-9 -5 -11 -4 -6 4 4 6 11 9 16 6 4 -3 18 10 29 29 24 37 27 51 9 40 -7 -4 -8
-3 -4 5 4 6 11 9 16 6 4 -3 15 6 24 20 19 29 20 39 4 29 -7 -4 -11 -5 -8 -1 3
3 8 5 11 4 9 -3 39 24 39 35 0 5 -5 6 -12 2 -7 -5 -8 -3 -4 5 5 7 11 10 14 7
7 -7 32 13 32 26 0 5 -6 6 -12 2 -8 -4 -10 -3 -5 2 5 5 12 9 15 9 13 0 32 16
32 26 0 6 -6 7 -12 3 -8 -4 -10 -3 -5 2 5 5 11 7 14 6 7 -5 63 50 63 62 0 5
-11 -1 -25 -14 -14 -13 -25 -21 -25 -19 0 3 19 23 42 44 23 22 34 29 23 15
-11 -14 2 -5 28 20 26 24 47 49 47 54 0 5 -11 -1 -25 -14 -14 -13 -25 -21 -25
-19 0 3 24 27 52 54 29 28 40 35 24 18 -17 -18 -25 -33 -20 -33 13 0 86 75 79
81 -2 3 12 21 32 40 20 19 33 28 29 22 -4 -7 -3 -13 2 -13 12 0 33 25 27 32
-3 3 3 11 12 19 16 13 17 12 4 -3 -7 -10 -9 -18 -4 -18 13 0 45 35 38 42 -3 3
3 11 12 19 16 13 17 12 4 -3 -7 -10 -9 -18 -3 -18 12 0 34 25 27 32 -3 3 2 11
12 19 11 9 14 10 9 2 -11 -19 0 -16 44 13 22 15 37 30 35 35 -3 4 0 11 6 15 8
5 9 3 4 -6 -5 -8 -3 -11 6 -8 8 3 14 10 14 15 0 6 4 15 9 20 5 5 6 2 1 -6 -5
-9 -3 -12 6 -9 8 3 14 10 14 15 0 6 4 15 9 20 5 5 6 2 1 -6 -5 -9 -3 -12 6 -9
8 3 13 11 11 17 -1 7 2 10 8 6 6 -4 48 13 93 38 404 218 895 314 1338 262z
m1340 -562 c13 -16 12 -17 -3 -4 -10 7 -18 15 -18 17 0 8 8 3 21 -13z m-3191
-26 c0 -1 -24 -25 -52 -52 l-53 -50 50 53 c46 48 55 57 55 49z m3345 -127 c10
-11 16 -20 13 -20 -3 0 -13 9 -23 20 -10 11 -16 20 -13 20 3 0 13 -9 23 -20z
m50 -60 c10 -11 16 -20 13 -20 -3 0 -13 9 -23 20 -10 11 -16 20 -13 20 3 0 13
-9 23 -20z m-20 -10 c10 -11 16 -20 13 -20 -3 0 -13 9 -23 20 -10 11 -16 20
-13 20 3 0 13 -9 23 -20z m60 -40 c10 -11 16 -20 13 -20 -3 0 -13 9 -23 20
-10 11 -16 20 -13 20 3 0 13 -9 23 -20z m-10 -20 c10 -11 16 -20 13 -20 -3 0
-13 9 -23 20 -10 11 -16 20 -13 20 3 0 13 -9 23 -20z m512 -1232 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-4660 -20 c-3 -7 -5 -2 -5 12 0 14 2
19 5 13 2 -7 2 -19 0 -25z m20 -50 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m4650 -200 c-2 -35 -3 -7 -3 62 0 69 1 97 3 63 2 -35 2 -91 0 -125z
m-4680 50 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m30 -150 c-3
-7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-20 -50 c-3 -7 -5 -2 -5 12
0 14 2 19 5 13 2 -7 2 -19 0 -25z m4660 -20 c-3 -7 -5 -2 -5 12 0 14 2 19 5
13 2 -7 2 -19 0 -25z m-4650 -60 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m10 -80 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m4173 -1051 c0 -2 -10 -12 -22 -23 l-23 -19 19 23 c18 21 26 27 26 19z m-60
-40 c0 -2 -10 -12 -22 -23 l-23 -19 19 23 c18 21 26 27 26 19z m-3564 -39 l29
-33 -32 29 c-31 28 -38 36 -30 36 2 0 16 -15 33 -32z m3584 29 c0 -2 -10 -12
-22 -23 l-23 -19 19 23 c18 21 26 27 26 19z m-3604 -39 l29 -33 -32 29 c-31
28 -38 36 -30 36 2 0 16 -15 33 -32z m3534 -11 c0 -1 -33 -34 -72 -72 l-73
-70 70 73 c64 67 75 77 75 69z m20 -10 c0 -1 -30 -32 -67 -67 l-68 -65 65 68
c60 62 70 72 70 64z m-3499 -44 c13 -16 12 -17 -3 -4 -17 13 -22 21 -14 21 2
0 10 -8 17 -17z m3299 -126 c0 -2 -12 -14 -27 -28 l-28 -24 24 28 c23 25 31
32 31 24z m10 -20 c0 -2 -12 -14 -27 -28 l-28 -24 24 28 c23 25 31 32 31 24z
m-3139 -24 c13 -16 12 -17 -3 -4 -17 13 -22 21 -14 21 2 0 10 -8 17 -17z
m3059 -16 c0 -2 -12 -14 -27 -28 l-28 -24 24 28 c23 25 31 32 31 24z m10 -20
c0 -2 -12 -14 -27 -28 l-28 -24 24 28 c23 25 31 32 31 24z m-2959 -54 c13 -16
12 -17 -3 -4 -10 7 -18 15 -18 17 0 8 8 3 21 -13z m44 -33 c10 -11 16 -20 13
-20 -3 0 -13 9 -23 20 -10 11 -16 20 -13 20 3 0 13 -9 23 -20z m1002 -436 c-3
-3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m546 -11 c-7 -2 -19 -2 -25
0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m134 -9 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6
6 11 1 17 -2 13 -5z m-424 -11 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24
-2 18 -5z m334 1 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M4789 4633 l-24 -28 28 24 c25 23 32 31 24 31 -2 0 -14 -12 -28 -27z"/>
<path d="M6196 3474 c-108 -26 -184 -70 -272 -158 -126 -125 -174 -240 -175
-412 0 -108 32 -222 84 -299 l34 -50 -18 -43 -18 -42 27 -31 28 -31 42 21 41
21 53 -33 c89 -57 161 -79 273 -85 178 -8 308 42 436 168 160 158 214 371 148
585 -40 130 -166 278 -291 341 -115 59 -270 78 -392 48z m269 -19 c348 -89
521 -462 369 -795 -52 -113 -135 -196 -262 -259 -213 -107 -490 -57 -652 116
-168 180 -205 427 -95 649 44 90 107 161 188 212 55 34 142 71 202 85 47 11
195 6 250 -8z m-523 -997 c-4 -4 -23 -9 -42 -10 -39 -3 -47 12 -30 57 l11 28
34 -33 c19 -19 32 -37 27 -42z"/>
<path d="M6215 3307 c-73 -25 -129 -59 -181 -113 -164 -167 -159 -422 11 -583
172 -163 418 -153 583 23 82 88 106 150 107 276 0 86 -3 101 -32 162 -44 93
-109 160 -200 205 -66 33 -85 37 -161 40 -53 2 -103 -2 -127 -10z m276 -44
c92 -43 142 -91 187 -181 35 -72 37 -81 37 -171 -1 -121 -25 -187 -96 -266
-184 -201 -522 -159 -639 79 -114 231 -9 482 235 563 24 8 73 12 125 10 71 -2
97 -8 151 -34z"/>
</g>
</svg>
);

export default SvgLocalizationStation;
